import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { TextZod } from '@/components/molecules/Text/TextType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { BubbleStyleZod } from '@/types/BubbleStyleType';

const TextMediaZod = z.object({
  __component: z.literal('block.text-media'),
  id: z.number(),
  text: TextZod,
  layout: z.enum(['par défaut', 'inversé']),
  logo: MediaZod.nullable(),
  picture: MediaZod,
  waveWrapper: WaveWrapperZod.nullable(),
  textBlobStyle: BubbleStyleZod.nullable(),
  imageBlobStyle: BubbleStyleZod.nullable(),
  logoBlobStyle: BubbleStyleZod.nullable(),
});

export { TextMediaZod };
export type TextMediaType = z.infer<typeof TextMediaZod>;
